export const NotificationEventsApi = {
    SOFT_ALERT: 'soft_alert',
    HARD_ALERT: 'hard_alert',
    ALARM: 'alarm',
};

export const NotificationEvents = {
    ALERT: 'alert',
    ALARM: 'alarm',
};